import React from 'react'
import {IoMdPerson} from 'react-icons/io'

const StandingsKey = ({anglers, fishCaught = 0, hide_fish_records}) => {

  //console.log('hide_fish_records passed  :::', hide_fish_records);

  return (
    <>

    <hr/>
    <div className="left">
      <small>
        <img src="/leaderboard/X.png" alt="TourneyX" className="standings-key"/> Angler Stats Available &nbsp;&nbsp;
        <img src="/leaderboard/green28x.png" alt="verified" className="standings-key"/> Verified &nbsp;&nbsp;
        <img src="/leaderboard/red28x.png" alt="unverified" className="standings-key"/> Unverified  &nbsp;&nbsp;Click to view Fish
      </small>
    </div>

    { (hide_fish_records && hide_fish_records == '1') ?

      <div className="right standings-total">
        <IoMdPerson className='angler-icon' /> Anglers: {anglers}
      </div>

      :

      <div className="right standings-total">
        <IoMdPerson className='angler-icon' /> Anglers: {anglers} • Fish Caught: {fishCaught}
      </div>
    }

    <div className="clear" />

    </>
  )
}

export default StandingsKey